import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import moment from "moment";
import ScheduledMaintenanceModal from "@/components/maintenance/ScheduledMaintenanceModal.vue";
import LaunchMaintenanceDrawer from "@/components/maintenance/LaunchMaintenanceDrawer.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "ScheduledMaintenanceList",
  components: {
    ScheduledMaintenanceModal: ScheduledMaintenanceModal,
    LaunchMaintenanceDrawer: LaunchMaintenanceDrawer,
    Confirm: Confirm
  },
  props: {
    archived: false
  },
  data: function data() {
    return _defineProperty(_defineProperty({
      items: [],
      datatable_loading: true,
      datatable_selected: [],
      datatable_headers: [{
        text: "Id",
        value: "id"
      }, {
        text: "Start Time",
        value: "start_time"
      }, {
        text: "End Time",
        value: "end_time"
      }, {
        text: "Description",
        value: "description"
      }, {
        text: "Alert Time Before Maintenance",
        value: "alert_threshold_minutes"
      }, {
        text: "Actions",
        value: "actions",
        sortable: false
      }]
    }, "datatable_loading", false), "errorMaintenance", null);
  },
  created: function created() {
    this.fetchScheduledMaintenance(1000);
    this.errorMaintenance = this.$maintenanceMode.errorMaintenance;
  },
  watch: {
    "$maintenanceMode.errorMaintenance": function $maintenanceModeErrorMaintenance(newValue) {
      this.errorMaintenance = this.$maintenanceMode.errorMaintenance;
    }
  },
  computed: {
    maintenanceMode: {
      get: function get() {
        return this.$maintenanceMode.isActive;
      }
    }
  },
  methods: {
    openScheduleMaintenanceModal: function openScheduleMaintenanceModal() {
      this.$refs.ScheduledMaintenanceModalRef.open();
    },
    fetchScheduledMaintenance: function fetchScheduledMaintenance(time) {
      var _this = this;
      this.$EventBus.$emit("loading", true);
      this.$maintenanceMode.fetchArchivedMaintenance();
      this.$maintenanceMode.fetchScheduledMaintenance();
      setTimeout(function () {
        if (_this.archived) {
          _this.items = _toConsumableArray(_this.$maintenanceMode.archivedMaintenance);
        } else {
          _this.items = _toConsumableArray(_this.$maintenanceMode.scheduledMaintenance);
        }
        _this.$EventBus.$emit("loading", false);
      }, time);
    },
    deleteScheduledMaintenance: function deleteScheduledMaintenance(id) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$refs.confirm.open("Delete", "Are you sure you want to delete this Maintenance ?", {
                color: "red"
              });
            case 2:
              confirmed = _context.sent;
              if (confirmed) {
                _this2.$maintenanceMode.deleteScheduledMaintenance(id);
                _this2.fetchScheduledMaintenance(1000);
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openLaunchMaintenanceDrawer: function openLaunchMaintenanceDrawer(id) {
      if (id) {
        this.$refs.launchMaintenanceDrawer.openDrawer(id, this.timeUntilEnd(id));
      } else {
        this.$refs.launchMaintenanceDrawer.openDrawer();
      }
    },
    deactivateMaintenanceMode: function deactivateMaintenanceMode() {
      this.$maintenanceMode.deactivate();
    },
    LaunchUpcomingMaintenance: function LaunchUpcomingMaintenance(id) {
      this.openLaunchMaintenanceDrawer(id);
    },
    formatDate: function formatDate(date) {
      return moment(date).format("LLL");
    },
    formatToStringDisplay: function formatToStringDisplay(time) {
      return new Date().formatMinutesToDaysHoursMinutes(time);
    },
    timeUntilEnd: function timeUntilEnd(id) {
      var maintenance = null;
      if (this.archived) {
        maintenance = this.$maintenanceMode.archivedMaintenance.find(function (x) {
          return x.id === id;
        });
      } else {
        maintenance = this.$maintenanceMode.scheduledMaintenance.find(function (x) {
          return x.id === id;
        });
      }
      var end = moment.utc(maintenance.end_time);
      var start = moment.utc(maintenance.start_time);
      return end.diff(start, "minutes");
    }
  }
};